import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { CustomModal } from '../../../../../../components/CustomModal/CustomModal';
import NewRequestContainer from '../../../../../CreateRequest/new-request.container';
import { Checkbox } from 'antd';

export const CreateRequestModal = forwardRef(
  (
    {
      setVisible,
      visible,
      visibleHintsCheck,
      visibleRequestsCheck,
      handleCheckHints,
      handleCheckRequests,
      canChangeVisibleHints,
      canChangeVisibleRequests,
    },
    ref
  ) => {
    const formRef = useRef(null);

    const handleUnmount = () => {
      formRef.current = null;
    };

    const handleSubmit = async () => {
      if (formRef.current && formRef.current.handleCreate) {
        const success = await formRef.current.handleCreate();
        if (success) {
          setVisible();
        }
      }
    };

    const handleCancelAndClear = async () => {
      if (formRef.current && formRef.current.handleCancel) {
        const success = await formRef.current.handleCancel();
        if (success) {
          setVisible();
        }
      }
    };

    useImperativeHandle(ref, () => ({
      tryClose: async () => {
        if (formRef.current && formRef.current.handleCancel) {
          return await formRef.current.handleCancel();
        }
        return true;
      },
    }));

    return (
      <CustomModal
        visible={visible}
        onOk={handleSubmit}
        onCancel={handleCancelAndClear}
        title="Новая заявка"
        okText="Создать"
        render={() => (
          <>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
              {canChangeVisibleHints && (
                <Checkbox
                  checked={visibleHintsCheck}
                  onChange={handleCheckHints}
                >
                  Подсказки
                </Checkbox>
              )}
              {canChangeVisibleRequests && (
                <Checkbox
                  checked={visibleRequestsCheck}
                  onChange={handleCheckRequests}
                >
                  Заявки
                </Checkbox>
              )}
            </div>
            <NewRequestContainer
              asModal={false}
              ref={formRef}
              onUnmount={handleUnmount}
            />
          </>
        )}
      />
    );
  }
);
